import { getCurrentProgress } from '../../../../backend/store';
import Settings from '../../../../settings/Settings';
import Session from '../../session/Session';
import Entry from './entry/Entry';

const TWEEN = {
    DURATION: 250,
    EASE: {
        SHOW: Phaser.Math.Easing.Back.Out,
        HIDE: Phaser.Math.Easing.Back.In,
    },
};

const MOVE = {
    DURATION: 125,
    EASE: Phaser.Math.Easing.Linear,
};

export default class Menu extends Phaser.GameObjects.Container {
    private bg!: Phaser.GameObjects.Image;
    private scrollZone: Phaser.GameObjects.Zone;
    private close!: Phaser.GameObjects.Image;
    private title!: Phaser.GameObjects.BitmapText;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.setupBG();
        this.setupClose();
        this.setupTitle();
        this.setupChapters();

        this.setScale(0);
    }

    setupBG() {
        let frame = 'comic/story_bg';

        this.bg = this.scene.add.image(0, 0, 'atlas', frame);
        this.bg.setScale(1.2)
        this.add(this.bg);
    }

    setupClose() {
        let x = 270;
        let y = -500;
        let frame = 'icons/close';

        this.close = this.scene.add.image(x, y, 'atlas', frame);
        this.add(this.close);

        this.close.setInteractive({ useHandCursor: true });

        // TODO remove once finished
        // this.close.once('pointerdown', () => this.emit('close'));
    }

    setupTitle() {
        this.title = this.scene.add.bitmapText(0, -535, Settings.FONTS.LXGW_CYRILLIC_BOLD, this.scene.cache.json.get('i18n')['STORY'], 70);
        this.title.setOrigin(0.5, 0);
        this.add(this.title);

    }

    setupChapters() {
        const padding = 5;
        const entryHeight = Entry.HEIGHT + padding;
        const visibleCount = 4;
        const maskHeight = visibleCount * entryHeight;
        const startY = -415;

        const scrollContainer = this.scene.add.container(0, startY);
        this.add(scrollContainer);

        let total = Session.Instance.story.totalChapters;
        let unlocked = Session.Instance.story.unlocked;

        for (let i = 0; i < total; i++) {
            const y = i * entryHeight;
            const id = i + 1;
            // const isLocked = unlocked.indexOf(id) === -1;
            const progress = getCurrentProgress();
            const isLocked = id > progress;

            const description = this.scene.cache.json.get('i18n')['desc_chapter'];

            const entry = new Entry(this.scene, 0, y, { id, isLocked, description });
            scrollContainer.add(entry);
            entry.on('click', (id: number) => this.emit('show_chapter', id));
        }

        const centerX = this.scene.cameras.main.centerX;
        const maskX = centerX - 600;
        const centerY = this.scene.cameras.main.height / 2;
        const shape = this.scene.make.graphics({ x: 0, y: startY });
        shape.fillStyle(0xffffff);
        shape.fillRect(maskX, centerY - maskHeight / 100, 1200, maskHeight);


        const mask = shape.createGeometryMask();
        scrollContainer.setMask(mask);

        this.scrollZone = this.scene.add.zone(0, 0, this.bg.width, this.bg.height)
        this.add(this.scrollZone)

        let lastY: number | null = null;
        let lastYY: number | null = null;

        this.scrollZone.setInteractive({ useHandCursor: true });

        this.scrollZone.on('pointerdown', (pointer: Phaser.Input.Pointer) => {
            lastY = pointer.y;
            lastYY = pointer.y;
            this.scene.input.topOnly = false;
        });

        this.scrollZone.on('pointermove', (pointer: Phaser.Input.Pointer) => {
            if (!pointer.isDown || lastY === null) return;
            const deltaY = pointer.y - lastY;
            if (lastYY && Math.abs(pointer.y - lastYY) > 5) this.scene.input.topOnly = true;
            scrollContainer.y += deltaY;
            lastY = pointer.y;

            const maxY = startY;
            const minY = startY - ((total - visibleCount) * entryHeight);
            scrollContainer.y = Phaser.Math.Clamp(scrollContainer.y, minY, maxY);
        });

        this.scrollZone.on('pointerup', () => {
            lastY = null;
            lastYY = null;
            this.scene.input.topOnly = true;
        });
    }


    show(): Promise<void> {
        return new Promise((resolve) => {
            this.scene.tweens.add({
                targets: this,
                scaleX: 1,
                scaleY: 1,
                duration: TWEEN.DURATION,
                ease: TWEEN.EASE.SHOW,
                onComplete: () => {
                    this.close.once('pointerdown', () => this.emit('close'));
                    resolve();
                },
            });
        });
    }

    hide(): Promise<void> {
        return new Promise((resolve) => {
            this.scene.tweens.add({
                targets: this,
                scaleX: 0,
                scaleY: 0,
                duration: TWEEN.DURATION,
                ease: TWEEN.EASE.HIDE,
                onComplete: () => resolve(),
            });
        });
    }

    moveOut(): Promise<void> {
        let dist = this.scene.cameras.main.width;

        return new Promise((resolve) => {
            this.scene.tweens.add({
                targets: this,
                x: `-=${dist}`,
                duration: MOVE.DURATION,
                ease: MOVE.EASE,
                onComplete: () => resolve(),
            });
        });
    }

    moveIn(): Promise<void> {
        let dist = this.scene.cameras.main.width;

        return new Promise((resolve) => {
            this.scene.tweens.add({
                targets: this,
                x: `+=${dist}`,
                duration: MOVE.DURATION,
                ease: MOVE.EASE,
                onComplete: () => resolve(),
            });
        });
    }
}
